/** The isolated admin panel (Tailscale only, own session). */
const ADMIN_PANEL_URL = "https://admin-panel.taile3ccd4.ts.net";

/** A page of the admin panel, e.g. `adminPanelHref("/returns/carrier-issues")`. */
export const adminPanelHref = (path: string) => `${ADMIN_PANEL_URL}${path}`;
